
import Vue from 'vue'
import Card from '~/components/atoms/Card.vue'
import AuthServiceList from '~/components/organisms/AuthServiceList.vue'

export default Vue.extend({
  components: {
    Card,
    AuthServiceList,
  },
})
